// Template226: Kuala Lumpur - Día 3 Batu Caves (Page9)
// Portada Batu Caves + title + sticker, intro, block Batu Caves + 2 SabiasQue, párrafo cuevas, sticker2, tip, Cómo llegar.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template226 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const blockTitle = page?.texts?.[3]?.content;
	const blockBody = page?.texts?.[4]?.content;
	const paragraphBox = page?.texts?.[5]?.content;
	const tipText = page?.texts?.[6]?.content;
	const llegarTitle = page?.texts?.[7]?.content;
	const llegarList = page?.texts?.[8]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const imgBlock = getImageSrc("img-block");
	const sticker2 = getImageSrc("sticker2");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
						/>
					)}
					{titleOverlay && (
						<Box
							component="h1"
							sx={{
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{titleOverlay}
						</Box>
					)}
				</Box>
			)}

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={{ ...estiloP, color: "#333" }}>
						{intro}
					</Box>
				</Box>
			)}

			<Box data-block-id="text-2" sx={{ padding: "0 12px", position: "relative", marginTop: 0 }}>
				{/* Block Batu Caves */}
				<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
					{imgBlock && (
						<Box
							component="img"
							src={imgBlock}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{blockTitle && (
							<Box component="h3" sx={estiloH3}>
								{blockTitle}
							</Box>
						)}
						{blockBody && (
							<Box component="p" sx={estiloP}>
								{blockBody}
							</Box>
						)}
					</Box>
				</Box>

				<Box style={{ position: "relative" }}>
					{sabiasQue[0] && (
						<Box sx={{ position: "absolute", bottom: -15, right: "55%" }}>
							<SabiasQue
								icono={sabiasQue[0].icono}
								texto={sabiasQue[0].texto}
							/>
						</Box>
					)}
					{sabiasQue[1] && (
						<Box sx={{ position: "absolute", bottom: -15, right: "45%" }}>
							<SabiasQue
								icono={sabiasQue[1].icono}
								texto={sabiasQue[1].texto}
							/>
						</Box>
					)}
					{sticker2 && (
						<Box
							component="img"
							src={sticker2}
							alt=""
							sx={{
								width: 120,
								position: "absolute",
								bottom: -120,
								left: -18,
							}}
						/>
					)}

					{tipText && (
						<Box
							sx={{
								position: "absolute",
								bottom: -80,
								left: 100,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 300,
							}}
						>
							{tipText}
						</Box>
					)}
					{paragraphBox && (
						<Box
							component="p"
							sx={{
								...estiloP,
								color: "#000",
								padding: 2.5,
								backgroundColor: "#dee7e3",
								borderRadius: "12px",
								marginTop: 1.5,
							}}
						>
							{paragraphBox}
						</Box>
					)}
				</Box>

				{(llegarTitle || llegarList) && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#dee7e3",
							border: "3px solid #2E7D5B",
							borderRadius: "12px",
							padding: "10px 20px",
							fontSize: 12,
							color: "#333",
							width: isSmallScreen ? "100%" : "100%",
							marginTop: 12.5,
						}}
					>
						{llegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: "#2e7d5b",
									textTransform: "uppercase",
								}}
							>
								{llegarTitle}
							</Box>
						)}
						{llegarList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: llegarList }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template226.thumbnail = "/images/template-1.png";
export default Template226;
